import type { JSONContent } from "@tiptap/react";

/**
 * Normalizes email content into the row/cell grid structure.
 *
 * Every top-level node that isn't already an emailRow gets wrapped in
 * `emailRow > emailCell[colSpan=4]`. This handles both fully-legacy
 * documents and mixed content (e.g. bare paragraphs + existing rows
 * from a signature or template).
 */
export function normalizeEmailContent(
  doc: JSONContent | undefined,
): JSONContent | undefined {
  if (!doc || !doc.content || doc.content.length === 0) {
    return doc;
  }

  let changed = false;
  const normalizedContent = doc.content.map((node) => {
    if (node.type === "emailRow") return node;
    changed = true;
    return wrapInRow(node);
  });

  return changed ? { ...doc, content: normalizedContent } : doc;
}

function wrapInRow(node: JSONContent): JSONContent {
  return {
    type: "emailRow",
    content: [
      {
        type: "emailCell",
        attrs: { colSpan: 4 },
        content: [node],
      },
    ],
  };
}
